import { useTranslation } from 'react-i18next'
import { IconButton, Tooltip } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import { useCurrentUser } from '@/hooks/useCurrentUser'
import { ADMIN_ROLE_ID } from '@/config/roles'
import { useIsBelowMd } from '@/hooks/useLayoutMode'

interface EditThisPageButtonProps {
  adminPath: string
}

export function EditThisPageButton({ adminPath }: EditThisPageButtonProps) {
  const { t } = useTranslation()
  const { data: user } = useCurrentUser()
  const isAdmin = user?.roles.some(r => r.id === ADMIN_ROLE_ID) ?? false
  // The button deep-links into the admin panel, which is blocked below md, so it
  // would land the user on AdminUnavailableNotice. Hidden at the same threshold.
  const isBelowMd = useIsBelowMd()

  if (!isAdmin || isBelowMd) return null

  return (
    <Tooltip title={t('practiceContent.editPageAdmin')} placement="bottom">
      <IconButton
        component="a"
        href={adminPath}
        aria-label={t('practiceContent.editPageAdmin')}
        size="medium"
        className="edit-page-btn"
      >
        <EditIcon fontSize="medium" />
      </IconButton>
    </Tooltip>
  )
}
